import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: ReactNode
    title: string
    description?: ReactNode
    action?: ReactNode
    className?: string
}

export const EmptyState: FC<EmptyStateProps> = ({
    icon,
    title,
    description,
    action,
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-card/60 px-6 py-10 text-center', className)}>
            <span className='grid size-12 place-items-center rounded-full bg-accent text-primary [&_svg]:size-6'>
                {icon}
            </span>

            <p className='mt-4 font-heading text-base font-bold text-foreground'>
                {title}
            </p>

            {description && (
                <p className='mt-1 max-w-xs text-sm leading-relaxed text-muted-foreground'>
                    {description}
                </p>
            )}

            {action && (
                <div className='mt-5'>
                    {action}
                </div>
            )}
        </div>
    )
}
